/**
 * @author Huangxiaoxun<hxx09448@gmail.com>
 * @date 2019/1/15
 */
import { getRunTime } from '../../../public-resource/libs/utils/index'
import { axios as $http } from 'cm'
import { getPlatform } from '../../../frontend-lib/tools/getPlatform'
import qs from 'qs'
import AliVerif from '../AliVerif/index'
const HOST = getRunTime('//m.xinli001.com')

export default class LoginModal extends AliVerif {
  /**
   * @param el       需要插入的dom节点
   * @param callBack 提交时的回调
   * @param theme    主色调
   *
   */
  constructor(el, callBack, theme) {
    super('#nc')
    this.el = document.getElementsByClassName(el)[0]
    this._ele = null
    this.renderTemplate(theme)
    this.isSendVerify = false
    // this.count = 60
    this.phone = null
    this.getCodeBtn = document.getElementById('getCode')
    this.waitBtn = document.getElementsByClassName('wait-btn')[0]
    this.submit = document.getElementById('submit')
    this.callBack = callBack
    // 指定实例化阿里验证后的回调函数
    this.slid_nc_opt.callback = this.getVerify.bind(this)
    console.log(this.nc_sence, this.nc_token)
    this.initEvents()
  }

  checkPhone(val) {
    console.log(val)
    let reg = /^((1[0-9][0-9])+\d{8})$/
    return val == '' ? false : reg.test(val)
  }

  /**
   *
   * @param data 这个data是阿里传入的
   * @returns {Promise.<void>}
   */
  async getVerify(data) {
    const url = `${HOST}/ajax/check-validate-aliyun`
    // const url = `http://m-box3.xinli001.com/ajax/check-validate-aliyun`
    this.phone = +document.getElementById('mobile').value
    $http
      .post(
        url,
        qs.stringify({
          account: this.phone,
          nc_sessionid: data.csessionid,
          nc_token: this.nc_token,
          nc_sig: data.sig,
          nc_scene: this.nc_sence,
          appkey: this.nc_appKey,
          // "is_oversea": isOversea
          is_oversea: 0
        })
      )
      .then(res => {
        console.log('res', res)
        if (res.data.code === null) {
          window.toast(res.data.message)
          this.isSendVerify = true
          this.handleVerify()
        } else {
          window.toast(res.data.message)
        }
      })
  }

  handleVerify() {
    document.getElementsByClassName('get-code-btn')[0].style.display = 'none'
    document.getElementsByClassName('wait-btn')[0].style.display = 'block'
    let count = document.getElementById('codeNum')
    let countTotal = +count.innerHTML
    console.log(countTotal)
    let intervalId = setInterval(() => {
      if (countTotal >= 1) {
        countTotal--
        count.innerHTML = countTotal
      } else {
        document.getElementsByClassName('get-code-btn')[0].style.display =
          'block'
        document.getElementsByClassName('wait-btn')[0].style.display = 'none'
        // ------------------------
        count.innerHTML = 60
        this.isSendVerify = false
        clearInterval(intervalId)
      }
    }, 1000)
  }

  async bindGetCode() {
    let mobileNumble = document.getElementById('mobile').value
    if (!this.checkPhone(mobileNumble)) {
      window.toast('请输入正确的手机号码')
      return
    }

    if (this.isSendVerify) {
      window.toast('请稍后再试')
      return
    }

    this.initNc(this.slid_nc_opt)
  }

  async bindSumbit(e) {
    let verifyCodeEle = document.getElementById('code')
    let verifyCode = document.getElementById('code').value
    if (!verifyCode) {
      window.toast('请输入验证码')
      return
    }

    if (verifyCode.split('').length !== 6) {
      window.toast('验证码错误')
      return
    }

    try {
      await this.callBack(this.phone, +document.getElementById('code').value)
      this.closeModal()
    } catch (e) {
      console.log(e)
    }
  }

  initEvents() {
    console.log('this.getCodeBtn', this.getCodeBtn)
    this.getCodeBtn.addEventListener('click', this.bindGetCode.bind(this))
    this.submit.addEventListener('click', this.bindSumbit.bind(this))
    this._ele.addEventListener('click', this.closeModal.bind(this))
    document.getElementById('bindmobile').addEventListener('click', e => {
      e.stopImmediatePropagation()
    })
  }

  openModal() {
    this._ele.style.display = 'block'
    // handleModal.afterOpen();
  }

  closeModal(e) {
    // handleModal.beforeClose();
    this._ele.style.display = 'none'
  }

  renderTemplate(theme) {
    let ele = document.createElement('div')
    // console.log('this.count',this.this.count)
    ele.setAttribute('class', 'dialog')
    let color = theme || '#0B8Bff'
    let template = `     <div class="content" id="bindmobile">
            <p class="dialog_title">输入手机号验证</p>
            <div class="main">
                <div class="from-wrap">
                    <input type="tel" class="mobile" id="mobile" maxlength="11" placeholder="请输入手机号">
                    <div class="test-warp">
                        <input type="text" id="code" class="get-code" maxlength="6" placeholder="请输入验证码">
                        <button  class="get-code-btn" style="border-color: ${color}; color: ${color}" id="getCode">获取验证码</button>
                        <button  class="wait-btn"><span id="codeNum">60</span>秒后重试</button>
                    </div>
                    <div id="nc"></div>
                </div>
                <div class="submit-btn" style="background:${color}" id="submit">确定</div>
            </div>
        </div>`

    ele.innerHTML = template
    this._ele = ele
    this.el.appendChild(this._ele)
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/components/LoginModal/dialog.js